import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@sprint-expert/app/app.component';
import { appConfig } from '@sprint-expert/app/app.config';
import { register as registerSwiperElements } from 'swiper/element/bundle';

registerSwiperElements();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
